/*
 * Copyright (c) 2024 InvestNYou. All rights reserved.
 * 
 * This software is protected by copyright law. Unauthorized copying,
 * reproduction, or distribution of this software, in whole or in part,
 * without the express written permission of InvestNYou, is strictly
 * prohibited.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
